<template>
  <div class="container" id="container-main">
    <template v-if="!error && !loading">
      <div class="level">
        <div class="level-left">
          <div class="date-selector is-flex"></div>
          <b-tooltip v-if="hasAutoRefresh" label="Auto refresh enabled" position="is-bottom">
            <b-icon icon="triangle-exclamation" pack="fas"></b-icon>
          </b-tooltip>
        </div>
        <div class="level-right">
          <div class="is-flex">
            <b-select v-model="selectedRegion" @input="FilterRegion()">
              <option value="All Regions">All Regions</option>
              <option v-for="region in regions" :key="region" :value="region">{{ region }}</option>
            </b-select>
          </div>
        </div>
      </div>
      <div class="tile" v-if="!this.loading && this.loaded">
        <div class="tile is-ancestor is-vertical">
          <div class="tile">
            <!-- Top Tile -->
            <div class="tile headingTile is-5 is-vertical">
              <div class="sectionHeading"><h2>Conversion Rates</h2></div>
              <div class="tile">
                <div class="tile is-parent">
                  <div class="tile is-child notification">
                    <current-conversion-rate v-if="loading != true" :stats="stats" :customers="customers" mode="actual" :selectedDate="selectedDate" :dayMode="mode"></current-conversion-rate>
                  </div>
                </div>
                <div class="tile is-parent">
                  <div class="tile is-child notification">
                    <current-conversion-rate v-if="loading != true && mode == 'current'" :stats="stats" :customers="customers" :selectedDate="selectedDate" :dayMode="mode"></current-conversion-rate>
                    <div class="is-flex is-flex-direction-column is-align-items-center flex-gap-20 height-100" v-else>
                      <h2 class="is-size-5">Total Bookings</h2>
                      <p class="is-size-2 is-flex is-justify-content-center is-align-items-center height-100">{{ TotalBookings }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent">
                  <div class="tile is-child notification">
                    <number-present :count="liveCustomerCount" :title="'Customers Live'"></number-present>
                  </div>
                </div>
                <div class="tile is-parent">
                  <div class="tile is-child notification">
                    <number-present :count="remainingCustomerCount" :title="'Remaining Customers'"></number-present>
                  </div>
                </div>
              </div>
            </div>
            <div class="tile headingTile">
              <div class="sectionHeading"><h2>Bookings</h2></div>
              <div class="tile is-vertical">
                <div class="tile is-parent">
                  <div class="tile is-child notification small">
                    <historic-bookings :period="1" :timeframe="'hours'" :customerid="'0'" :region="this.selectedRegion" :customers="this.customers"></historic-bookings>
                  </div>
                </div>
                <div class="tile is-parent">
                  <div class="tile is-child notification small">
                    <historic-bookings :period="7" :timeframe="'days'" :customerid="'0'" :region="this.selectedRegion" :customers="this.customers"></historic-bookings>
                  </div>
                </div>
              </div>
              <div class="tile is-vertical">
                <div class="tile is-parent">
                  <div class="tile is-child notification small">
                    <bookings-today :stats="this.stats" :customers="this.customers" :region="this.selectedRegion" :customerid="'0'"></bookings-today>
                  </div>
                </div>
                <div class="tile is-parent">
                  <div class="tile is-child notification small">
                    <historic-bookings :period="1" :timeframe="'month'" :customerid="'0'" :region="this.selectedRegion" :customers="this.customers"></historic-bookings>
                  </div>
                </div>
              </div>
              <div class="tile is-vertical">
                <div class="tile is-parent">
                  <div class="tile is-child notification small">
                    <historic-bookings :period="24" :timeframe="'hours'" :customerid="'0'" :region="this.selectedRegion" :customers="this.customers"></historic-bookings>
                  </div>
                </div>
                <div class="tile is-parent">
                  <div class="tile is-child notification small">
                    <historic-bookings :period="1" :timeframe="'year'" :customerid="'0'" :region="this.selectedRegion" :customers="this.customers"></historic-bookings>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tile">
            <!-- Middle tile -->
            <div class="tile is-vertical is-5">
              <!-- left -->
              <div class="tile is-parent">
                <div class="tile is-child notification">
                  <total-bookings v-if="loading != true" :stats="stats" :customers="customers" mode="todayvslastweek" :selectedDate="selectedDate"></total-bookings>
                </div>
              </div>
              <div class="tile is-parent">
                <div class="tile is-child notification">
                  <conversion-rates v-if="loading != true" :stats="stats" :customers="customers" :selectedDate="selectedDate"></conversion-rates>
                </div>
              </div>
            </div>
            <div class="tile">
              <!-- right -->
              <div class="tile is-parent">
                <div class="tile is-child notification">
                  <customers-table v-if="loading != true" :stats="stats" :customers="customers" :selectedDate="selectedDate" :mode="mode"></customers-table>
                </div>
              </div>
            </div>
          </div>
          <div class="tile">
            <!-- Bottom -->
            <div class="tile is-vertical">
              <div class="tile is-parent">
                <div class="tile is-child notification">
                  <region-bookings v-if="loading != true" :stats="dashboardData" :customers="allCustomers" :regions="regions" :selectedDate="selectedDate" :mode="mode"></region-bookings>
                </div>
              </div>
              <div class="tile is-parent">
                <div class="tile is-child notification">
                  <div class="google-map"><google-map :zoom="2.5" :options="{}" :heatmapPoints="bookingLocations"></google-map></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="loading">
      <div class="is-flex is-justify-content-center">
        <div class="box loading-box">
          <div class="is-flex is-flex-direction-column is-align-items-center">
            <b-icon icon="sync-alt" pack="fas" size="is-large" custom-class="fa-spin"></b-icon>
            <h1 class="is-size-2">Loading</h1>
            <p class="is-size-6 has-text-grey-light">This might take a hot minute</p>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="box">
        <div class="is-flex is-flex-direction-column is-align-items-center">
          <b-icon icon="bug" pack="fas" size="is-large"></b-icon>
          <h1 class="is-size-2">An unexpected error has occured</h1>
          <p class="is-size-6 has-text-grey-light">Please try refreshing in a few moments. If this issue persists, please contact support</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
const axios = require("axios");
const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");
dayjs.extend(utc);
import TotalBookings from "./charts/TotalBookings.vue";
import ConversionRates from "./charts/ConversionRates.vue";
import CurrentConversionRate from "./charts/CurrentConversionRate.vue";
import CustomersTable from "./charts/CustomersTable.vue";
import RegionBookings from "./charts/RegionBookings.vue";
import HistoricBookings from "./charts/HistoricBookings.vue";
import BookingsToday from "./charts/TotalBookingsToday.vue";
import NumberPresent from "./charts/NumberPresent.vue";
import GoogleMap from "../../../components/common/GoogleMap.vue";

export default {
  components: {
    TotalBookings,
    ConversionRates,
    CurrentConversionRate,
    CustomersTable,
    RegionBookings,
    HistoricBookings,
    BookingsToday,
    NumberPresent,
    GoogleMap,
  },
  data: function () {
    return {
      apiUrl: "https://api.jeak.co.uk",
      dashboardData: {},
      stats: {},
      customers: [],
      loaded: false,
      loading: true,
      backgroundTimer: null,
      lastRefresh: null,
      nextRefresh: null,
      regions: [],
      selectedRegion: "All Regions",
      selectedDate: new Date(),
      allCustomers: [],
      error: false,
      bookingLocations: [],
      requestSequence: 0,
      cacheTimestamp: 0,
      pendingGetItems: false,
      cachedStatsByRegion: {},
      cacheMaxAge: 1800000, // 30 minutes in ms
    };
  },
  methods: {
    LoadFromStorage: function () {
      try {
        const stored = localStorage.getItem("dashboardCache");
        if (stored) {
          const cacheData = JSON.parse(stored);
          this.dashboardData = cacheData.data || {};
          this.cacheTimestamp = cacheData.timestamp || 0;
        }
      } catch (err) {
        console.warn("Failed to load dashboard cache from storage:", err);
      }
    },
    SaveToStorage: function () {
      try {
        const cacheData = {
          data: this.dashboardData,
          timestamp: Date.now(),
        };
        localStorage.setItem("dashboardCache", JSON.stringify(cacheData));
        this.cacheTimestamp = Date.now();
      } catch (err) {
        console.warn("Failed to save dashboard cache to storage:", err);
      }
    },
    IsCacheFresh: function () {
      const now = Date.now();
      return this.cacheTimestamp && now - this.cacheTimestamp < this.cacheMaxAge;
    },
    GetItems: async function () {
      // Skip if request already pending to prevent duplicate API calls
      if (this.pendingGetItems) return;

      const requestId = ++this.requestSequence;
      this.stats = {};
      this.loading = true;
      this.loaded = false;
      this.error = false;
      this.pendingGetItems = true;

      try {
        // Load from persistent storage first
        this.LoadFromStorage();

        // Show cached data immediately if available (no loading spinner)
        const hasCachedData = Object.keys(this.dashboardData).length > 0;
        if (hasCachedData) {
          await this.FilterRegion(requestId);
        }

        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: "Bearer " + token },
        };

        // Optimize date calculations (do once instead of multiple times)
        const sevenDaysAgo = dayjs.utc(this.selectedDate).subtract(7, "day").hour(0);
        const fromDate = sevenDaysAgo.minute(0).second(0).add(10, "minute").format();
        const toDate = dayjs.utc(this.selectedDate).hour(23).minute(59).second(59).add(10, "minute").format();
        const fromDayKey = sevenDaysAgo.format("DD-MM-YYYY");
        const toDayKey = dayjs.utc(this.selectedDate).hour(23).format("DD-MM-YYYY");
        const todayKey = dayjs.utc(this.selectedDate).format("DD-MM-YYYY");
        const isCurrentDate = todayKey === dayjs().format("DD-MM-YYYY");

        // Fetch dashboard stats
        if ((!this.dashboardData[fromDayKey] || !this.dashboardData[toDayKey]) && !this.IsCacheFresh()) {
          const response = await axios.get(this.apiUrl + `/stats/dashboard?from=${fromDate}&to=${toDate}`, config);
          if (requestId !== this.requestSequence) {
            this.pendingGetItems = false;
            return;
          }
          for (const [key, value] of Object.entries(response.data)) {
            this.dashboardData[key] = value;
          }
          this.SaveToStorage();

          // Prune old cache entries to prevent unbounded growth (keep last 30 days)
          const cacheKeys = Object.keys(this.dashboardData);
          const thirtyDaysAgo = dayjs().subtract(30, "day").format("DD-MM-YYYY");
          for (const cacheKey of cacheKeys) {
            try {
              if (dayjs(cacheKey, "DD-MM-YYYY").isBefore(dayjs(thirtyDaysAgo, "DD-MM-YYYY"))) {
                delete this.dashboardData[cacheKey];
              }
            } catch (pruneErr) {
              // Skip invalid date keys
            }
          }
          this.SaveToStorage();
        }

        // Set next refresh only once if current date
        if (isCurrentDate && !this.nextRefresh) {
          this.lastRefresh = dayjs();
          let nextRefreshTime = dayjs().add(1, "hour").minute(5);
          this.nextRefresh = dayjs(`${nextRefreshTime.format("YYYY-MM-DD")}T${nextRefreshTime.format("HH:mm")}`);
        } else if (!isCurrentDate) {
          this.nextRefresh = null;
        }

        // Fetch booking locations (sequential to preserve compatibility)
        this.bookingLocations = [];
        try {
          const locationsResponse = await axios.get(this.apiUrl + `/stats/booking-locations?date=${dayjs(this.selectedDate).format("YYYY-MM-DD")}`, config);
          if (requestId !== this.requestSequence) {
            this.pendingGetItems = false;
            return;
          }
          for (const location of locationsResponse.data) {
            if (this.bookingLocations.length < 10000) {
              this.bookingLocations.push({ lat: location.lat, long: location.lng });
            }
          }
        } catch (locErr) {
          // Booking locations failure does not block dashboard - log but continue
          console.warn("Booking locations fetch failed:", locErr);
        }

        await this.FilterRegion(requestId);
      } catch (err) {
        if (requestId !== this.requestSequence) {
          this.pendingGetItems = false;
          return;
        }
        this.error = true;
        this.loading = false;
        this.loaded = false;
      } finally {
        this.pendingGetItems = false;
      }
    },
    FilterRegion: async function (requestId = null) {
      this.stats = {};
      await this.$nextTick();
      if (requestId !== null && requestId !== this.requestSequence) return;

      // Check if stats already cached for this region
      const cacheKey = `region_${this.selectedRegion}`;
      if (this.cachedStatsByRegion[cacheKey]) {
        this.stats = this.cachedStatsByRegion[cacheKey];
        this.loading = false;
        this.loaded = true;
        return;
      }

      if (this.selectedRegion == "All Regions") {
        this.stats = this.dashboardData;
        this.cachedStatsByRegion[cacheKey] = this.stats;
        this.loading = false;
        this.loaded = true;
        return;
      }

      for (const [day, dayData] of Object.entries(this.dashboardData)) {
        if (!this.stats[day]) {
          this.stats[day] = {};
        }
        for (const [time, timeData] of Object.entries(dayData)) {
          if (!this.stats[day][time]) {
            this.stats[day][time] = {};
          }
          for (const [customerId, customerData] of Object.entries(timeData)) {
            let foundCustomer = this.allCustomers.find((customerSearch) => {
              return customerSearch.id == customerId;
            });
            if (!foundCustomer || !foundCustomer.billing_region) continue;
            if (foundCustomer.billing_region.toLowerCase() == this.selectedRegion.toLowerCase()) {
              this.stats[day][time][customerId] = customerData;
            } else {
              continue;
            }
          }
        }
      }

      // Cache the filtered stats for this region
      this.cachedStatsByRegion[cacheKey] = this.stats;

      if (requestId !== null && requestId !== this.requestSequence) return;
      this.loading = false;
      this.loaded = true;
    },
    GetCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(this.apiUrl + "/customers", config);
      this.customers = [];
      response.data.forEach((customer) => {
        this.customers.push(customer);
      });
    },
    GetRegions: async function () {
      let regions = [];
      for (const customer of this.allCustomers) {
        let foundRegion = regions.find((regionSearch) => {
          return regionSearch == customer.billing_region;
        });
        if (!foundRegion) {
          regions.push(customer.billing_region);
        }
      }
      this.regions = regions;
    },
    SetTimer: function () {
      if (this.backgroundTimer) {
        clearInterval(this.backgroundTimer);
        this.backgroundTimer = null;
      }
      // Only set timer for current date (when auto-refresh is possible)
      if (dayjs(this.selectedDate).format("DD-MM-YYYY") !== dayjs().format("DD-MM-YYYY")) {
        return;
      }
      this.backgroundTimer = setInterval(() => {
        if (this.nextRefresh && dayjs().isAfter(this.nextRefresh)) {
          this.GetItems();
        }
      }, 10000);
    },
    GetAllCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(`https://api.disctools.co.uk/api/customers`, config);
      this.allCustomers = [];
      response.data.data.forEach((customer) => {
        this.allCustomers.push(customer);
      });
      await this.GetRegions();
    },
  },
  computed: {
    hasAutoRefresh() {
      return !!this.nextRefresh;
    },
    TotalBookings() {
      let dayData = this.dashboardData[this.formattedSelectedDate];
      if (!dayData) return 0;
      let bookings = 0;
      for (const [, customerData] of Object.entries(dayData)) {
        for (const [, outcomes] of Object.entries(customerData)) {
          if (outcomes.booked) bookings += outcomes.booked;
        }
      }
      return bookings;
    },
    HourOutcomes() {
      let dayData = this.dashboardData[this.formattedSelectedDate];
      if (!dayData) return [];
      let outcomesArr = [];
      for (const [time, customerData] of Object.entries(dayData)) {
        for (const [, outcomes] of Object.entries(customerData)) {
          for (const [outcome, value] of Object.entries(outcomes)) {
            let foundOutcome = outcomesArr.find((outcomeSearch) => {
              return outcomeSearch.name == outcome;
            });
            if (!foundOutcome) {
              outcomesArr.push({ name: outcome, total: value, times: [{ time: time, value: value }] });
            } else {
              let foundHour = foundOutcome.times.find((hourSearch) => {
                return hourSearch.time == time;
              });
              if (!foundHour) foundOutcome.times.push({ time: time, value: value });
              else foundHour.value += value;
              foundOutcome.total += value;
            }
          }
        }
      }
      return outcomesArr;
    },
    formattedSelectedDate() {
      return dayjs(this.selectedDate).format("DD-MM-YYYY");
    },
    todayDateKey() {
      return dayjs().format("DD-MM-YYYY");
    },
    isCurrentDate() {
      return this.formattedSelectedDate === this.todayDateKey;
    },
    mode() {
      return this.isCurrentDate ? "current" : "historic";
    },
    liveCustomerCount() {
      if (this.selectedRegion == "All Regions") {
        return this.customers.length;
      } else {
        let found = this.allCustomers.filter((customerSearch) => {
          return (customerSearch.billing_region || "").toLowerCase() == this.selectedRegion.toLowerCase();
        });
        return found.length;
      }
    },
    remainingCustomerCount() {
      if (this.selectedRegion == "All Regions") {
        return this.allCustomers.length - this.customers.length;
      } else {
        let found = this.allCustomers.filter((customerSearch) => {
          return (customerSearch.billing_region || "").toLowerCase() == this.selectedRegion.toLowerCase();
        });
        this.customers.forEach((customer) => {
          let foundIndex = found.findIndex((customerSearch) => {
            return customerSearch.id == customer.disctools_id;
          });
          if (foundIndex > -1) {
            found.splice(foundIndex, 1);
          }
        });
        return found.length;
      }
    },
  },
  watch: {
    selectedDate() {
      // Clear region cache when date changes since data is date-specific
      this.cachedStatsByRegion = {};
    },
  },
  async mounted() {
    try {
      // Preload cache from storage for instant data access
      this.LoadFromStorage();

      // Run GetCustomers and GetAllCustomers in parallel (they're independent)
      await Promise.all([this.GetCustomers(), this.GetAllCustomers()]);

      await this.GetItems();
      this.SetTimer();
    } catch (err) {
      this.error = true;
    }
  },
  beforeDestroy() {
    if (this.backgroundTimer) {
      clearInterval(this.backgroundTimer);
      this.backgroundTimer = null;
    }
  },
};
</script>

<style scoped>
.container {
  max-width: unset !important;
  width: 100%;
  padding: 10px;
  max-height: calc(100% - 3.5rem);
}
.notification.is-info {
  background-color: #3e8ed0;
  color: #fff;
}
.regionSelector {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.small {
  max-height: 100px;
}
.notification {
  border-radius: 7px;
}
.tile.box {
  padding-top: 35px;
  position: relative;
}
.sectionHeading {
  position: absolute;
  top: 5px;
  left: 10px;
  font-size: min(6.5vw, 25px);
}
.tile.is-ancestor {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
}
.tile.headingTile {
  padding-top: 35px;
  position: relative;
  margin: 0;
}
.tile.is-parent {
  gap: 10px;
}
.google-map {
  width: 100%;
  height: 600px;
}
.loading-box {
  max-width: 400px;
  padding: 20px;
}
</style>

<style>
@media screen and (min-width: 1169px) {
  .tile:not(.is-child) {
    display: flex;
  }
}
</style>
